import React from 'react';
import { Link } from 'react-router-dom';

import logo from './../assets/logo-horizontal-dark.svg'

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300 py-12 border-t border-gray-800 mt-auto">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Top Section: Logo + Columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12">
          
          {/* Logo & Description (Takes up 2 columns on large screens) */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4 hover:opacity-80 transition-opacity">
              {/* Replace with your actual SVG logo path */}
              <img src={logo} alt="Recodeq Logo" className="object-contain filter" />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed max-w-sm">
              Pokročilý nástroj využívající AI pro efektivní vyhodnocování a analýzu otevřených otázek z průzkumů.
            </p>
          </div>

          {/* Column 1: Product */}
          <div>
            <h3 className="text-white font-semibold mb-4 uppercase text-sm tracking-wider">Produkt</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/analysis/create" className="text-sm hover:text-white transition-colors duration-200">
                  Nová analýza
                </Link>
              </li>
              <li>
                <Link to="/payments/calculator" className="text-sm hover:text-white transition-colors duration-200">
                  Ceník
                </Link>
              </li>
              <li>
                <Link to="/#jak-to-funguje" className="text-sm hover:text-white transition-colors duration-200">
                  Jak to funguje
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 2: Legal Notes */}
          <div>
            <h3 className="text-white font-semibold mb-4 uppercase text-sm tracking-wider">Právní doložka</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/terms" className="text-sm hover:text-white transition-colors duration-200">
                  Obchodní podmínky
                </Link>
              </li>
              <li>
                <Link to="/zasady-cookies" className="text-sm hover:text-white transition-colors duration-200">
                  Zásady zpracování osobních údajů
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4 uppercase text-sm tracking-wider">Kontakt</h3>
            <ul className="space-y-3">
              <li>
                <p className="text-sm">
                  info@recodeq.com
                </p>
              </li>
              <li>
                <p className="text-sm">
                  604 701 028
                </p>
              </li>
            </ul>
          </div>

        </div>

        {/* Divider */}
        <hr className="border-gray-800 my-8" />

        {/* Bottom Section: Company Info & Copyright */}
        <div className="flex flex-col md:flex-row justify-between items-center text-xs text-gray-500 space-y-4 md:space-y-0">
          <div className="flex flex-col text-xs text-gray-500 space-y-2 text-center md:text-left">
            <span>&copy; {currentYear} Recodeq · SURG Solutions s.r.o.</span>            
            <span>IČO 22442583 · Sídlo: Sídlištní 245/18A, Lysolaje, 165 00 Praha · Zapsaná v OR vedeném Městským soudem v Praze, sp. zn. C 409737</span>            
          </div>

        </div>

      </div>
    </footer>
  );
};

export default Footer;